module.exports = __webpack_public_path__ + "img/cook.b082e108.png";